// Thin wrapper around window.location.reload() so tests can jest.mock this
// module. jsdom 26 (bundled with Jest 30) makes both `window.location` and
// `window.location.reload` non-configurable + non-writable, so spying/patching
// the DOM directly is no longer possible.
export function reloadPage(): void {
  window.location.reload();
}
